import z from "zod";

const SEGMENT_TYPES = [
  "room",
  "room_entry",
  "room_and_university_entry",
  "room_and_stairs_entry",
  "room_entry_between_rooms",
  "library",
  "library_entry",
  "wardrobe",
  "wardrobe_entry",
  "entry",
  "corridor",
  "street",
  "stairs",
  "stairs_entry",
] as const;

// Единый источник истины для типов изображений
const IMAGE_TYPES = [
  "walk",
  "stairs_up",
  "stairs_down",
  "entry",
  "computer_room",
  "lab_room",
  "lecture_room",
  "wardrobe",
  "library",
] as const;

// Типы для TypeScript
export type SegmentTypesEnum = (typeof SEGMENT_TYPES)[number];
export type ImageTypesEnum = (typeof IMAGE_TYPES)[number];

// Zod enums
const segmentTypesZodEnum = z.enum(SEGMENT_TYPES);
const imageTypesZodEnum = z.enum(IMAGE_TYPES);

// Схема для точки маршрута
const pointSchema = z.object({
  meshName: z.string(),
  floor: z.number(),
  x: z.number(),
  y: z.number(),
  z: z.number(),
  parent: z.string(),
});

// Схема для сегмента маршрута
const directionSegmentSchema = z.object({
  id: z.number(),
  title: z.string(),
  subtitle: z.string().nullable(),
  startPointMeshName: z.string().nullable(),
  endPointMeshName: z.string().nullable(),
  parent: z.string(),
  parentNames: z.array(z.string()),
  floor: z.number(),
  type: segmentTypesZodEnum,
  imageType: imageTypesZodEnum,
  time: z.number(),
  pointMeshNames: z.array(z.string()),
});

// Схема для сегментированного маршрута
const segmentationRouteSchema = z.object({
  startPointMeshName: z.string(),
  endPointMeshName: z.string(),
  selectedFloors: z.array(z.number()),
  selectedStairs: z.array(z.string()),
  totalDuration: z.number(),
  totalDistance: z.number(),
  segments: z.array(directionSegmentSchema),
});

// Основная схема ответа
const directionSchema = z.object({
  points: z.array(pointSchema),
  segmentationRoute: segmentationRouteSchema,
});

// Экспорт типов
export type Direction = z.infer<typeof directionSchema>;
export type DirectionSegment = z.infer<typeof directionSegmentSchema>;
export type Point = z.infer<typeof pointSchema>;
export type SegmentationRoute = z.infer<typeof segmentationRouteSchema>;

// Экспорт констант
export { SEGMENT_TYPES, IMAGE_TYPES, directionSchema };
///// ==========================================================================

export interface Route {
  start: string;
  end: string;
}
